module.exports = __webpack_public_path__ + "img/mtn.4ed9b742.png";